export default function createApiData(data, queryParams) {
  const {
    id,
  } = data;
  const { departureDate, arrivalDate, pax, fromLocation, toLocation } = queryParams;

  const common = { id, num_pax: Number(pax), quantity: 1 };
  const transportation = [];

  transportation.push({
    ...common,
    to: toLocation,
    from: fromLocation,
    start_date: departureDate,
  });

  if (arrivalDate) {
    transportation.push({
      ...common,
      to: fromLocation,
      from: toLocation,
      start_date: arrivalDate,
    });
  }

  return { transportation };
}


// WEBPACK FOOTER //
// ./src/screens/Transportation/Common/createDataForInvoice.js